import { render } from "./AppointmentIndex.vue?vue&type=template&id=1190f8bc"
import script from "./AppointmentIndex.vue?vue&type=script&lang=js"
export * from "./AppointmentIndex.vue?vue&type=script&lang=js"

import "./AppointmentIndex.vue?vue&type=style&index=0&id=1190f8bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__